import { IconLayoutSidebar, IconPlus, IconSmartHome, IconSearch, IconBrandSafari } from "@tabler/icons-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import SidebarProfile from "./SidebarProfile";

interface SidebarCollapsedProps {
  onExpand: () => void;
  onHomeClick: () => void;
  onSearchClick: () => void;
  onExploreClick: () => void;
  onNewTopicClick: () => void;
}

const SidebarCollapsed = ({ 
  onExpand, 
  onHomeClick, 
  onSearchClick, 
  onExploreClick, 
  onNewTopicClick
}: SidebarCollapsedProps) => {
  return (
    <div className="flex-1 flex flex-col h-full pb-4" style={{ backgroundColor: '#EBEBEB' }}>
      <TooltipProvider>
        {/* Logo and Expand Button */}
        <div className="p-4 flex items-center justify-center py-[12px]">
          <div 
            onClick={onExpand}
            className="cursor-pointer p-2 rounded-lg hover:bg-white/50 transition-all duration-200"
          >
            <IconLayoutSidebar className="w-6 h-6 text-gray-600" stroke={1.6} />
          </div>
        </div>

        {/* Main Navigation Icons */}
        <div className="space-y-1 px-3 mb-3 pb-3 border-b border-gray-300">
          {/* Home Icon */}
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                onClick={onHomeClick}
                className="flex items-center justify-center p-2 rounded-lg transition-all duration-200 hover:bg-white/50 cursor-pointer"
              >
                <IconSmartHome className="w-5 h-5 text-gray-600" stroke={1.6} />
              </div>
            </TooltipTrigger>
            <TooltipContent side="right">
              <span>Home</span>
            </TooltipContent>
          </Tooltip>

          {/* Search Icon */}
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                onClick={onSearchClick}
                className="flex items-center justify-center p-2 rounded-lg transition-all duration-200 hover:bg-white/50 cursor-pointer"
              >
                <IconSearch className="w-5 h-5 text-gray-600" stroke={1.6} />
              </div>
            </TooltipTrigger>
            <TooltipContent side="right">
              <span>Search</span>
            </TooltipContent>
          </Tooltip>

          {/* Explore Icon */}
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                onClick={onExploreClick}
                className="flex items-center justify-center p-2 rounded-lg transition-all duration-200 hover:bg-white/50 cursor-pointer"
              >
                <IconBrandSafari className="w-5 h-5 text-gray-600" stroke={1.6} />
              </div>
            </TooltipTrigger>
            <TooltipContent side="right">
              <span>Explore</span>
            </TooltipContent>
          </Tooltip>
        </div>

        {/* New Topic Icon */}
        {/* <div className="px-3">
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                onClick={onNewTopicClick}
                className="flex items-center justify-center p-2 rounded-lg transition-all duration-200 hover:bg-white/50 cursor-pointer"
              >
                <IconPlus className="w-5 h-5 text-gray-600" stroke={1.6} />
              </div>
            </TooltipTrigger>
            <TooltipContent side="right">
              <span>New Topic</span>
            </TooltipContent>
          </Tooltip>
        </div> */}
      </TooltipProvider>

      {/* Profile Avatar at Bottom */}
      <SidebarProfile collapsed={true} />
    </div>
  );
};

export default SidebarCollapsed;